import Joi from "joi";

export const patientEditSchema = Joi.object({
  first_name: Joi.string().optional().allow(""),
  middle_name: Joi.string().optional().allow(""),
  last_name: Joi.string().optional().allow(""),
  email_address: Joi.string().email({ tlds: false }).optional().allow(""),
  gender: Joi.string().valid("M", "F", "O").optional().allow(""),
  occupation: Joi.string().optional().allow(""),
  religion: Joi.string().optional().allow(""),
  nationality: Joi.string().optional().allow(""),
  date_of_birth: Joi.string().optional().allow(""),
  married_for: Joi.string().optional().allow(""),
  trying_for: Joi.string().optional().allow(""),
  remarks: Joi.string().optional().allow(""),
});
